import { render, staticRenderFns } from "./vCol.vue?vue&type=template&id=4ead8dc8&scoped=true&"
import script from "./vCol.vue?vue&type=script&lang=js&"
export * from "./vCol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead8dc8",
  null
  
)

export default component.exports